module.exports = __webpack_public_path__ + "img/msbr-171.prt.31fb288b.jpg";